import RemoveButton from './component';

export default RemoveButton;
